import React, { ReactNode, useState } from 'react';
import { IconsMapType } from './SnapIcon/icons-mapper';
import { SnapIcon } from './SnapIcon';

export default function SnapAccordion({
  title,
  children,
  icon,
}: {
  title: string;
  children: ReactNode[];
  icon: IconsMapType;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className='w-full'>
      <div onClick={() => setIsOpen(!isOpen)} className='text-sm'>
        <SnapIcon icon={icon} /> {title}
      </div>
      <div
        className='transition-all overflow-hidden'
        style={{ display: isOpen ? 'block' : 'none' }}
      >
        {children}
      </div>
    </div>
  );
}
